// (A) 중립 스위치 API — antd 미접촉. (B) PlainSwitch 에 위임.
import type { CSSProperties } from 'react'
import { PlainSwitch } from '../_impl/PlainSwitch'

export interface OmwSwitchProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  disabled?: boolean
  size?: 'sm' | 'md'
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export function OmwSwitch(props: OmwSwitchProps) {
  return <PlainSwitch {...props} />
}
